export default [
    {
        path: 'analysis',
        name: 'analysis',
        meta: {
            access: ['AUTH_ANALYSIS'],
            title: 'analysis',
            icon: 'icon-fenxi',
            notPageView: true,
        },
        // redirect: { name: 'analysis_channel' },
        component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/Layout.vue'),
        children: [
            {
                path: 'channel',
                name: 'analysis_channel',
                meta: {
                    access: ['CHANNEL_AYALYSIS'],
                    title: 'analysis_channel',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/ChannelStatistics/index.vue'),
            },
            {
                path: 'data/customer',
                name: 'analysis_customer',
                meta: {
                    access: ['CUSTOMER_ANALYSIS'],
                    title: 'analysis_customer',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/CustomerAnalysis/index.vue'),
            },
            {
                path: 'data/overview',
                name: 'analysis_data_overview',
                meta: {
                    access: ['DATA_OVERVIEW'],
                    title: 'analysis_data_overview',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/Overview.vue'),
            },
            {
                path: 'data/duration',
                name: 'analysis_online_duration',
                meta: {
                    access: ['ONLINE_DURATION'],
                    title: 'analysis_online_duration',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/OnlineDuration/index.vue'),
            },
            {
                path: 'data/analysis',
                name: 'analysis_data_analysis',
                meta: {
                    access: ['DATA_ANALYSIS'],
                    title: 'analysis_data_analysis',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/BigReport/index.vue'),
            },
            {
                path: 'data/adversting',
                name: 'analysis_data_adversting',
                meta: {
                    access: ['DATA_FACEBOOK_ADS_INSIGHTS'],
                    title: 'analysis_data_adversting',
                    icon: 'icon-fenxi',
                },
                component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/Adversting/index.vue'),
                children: [
                    {
                        path: 'facebook',
                        name: 'analysis_data_adversting_facebook',
                        meta: {
                            hideInMenu: true,
                            access: ['DATA_FACEBOOK_ADS_INSIGHTS'],
                            title: 'analysis_data_adversting_facebook',
                            icon: 'icon-fenxi',
                        },
                        component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/Adversting/facebook/index.vue'),
                    },
                    {
                        path: 'messenger',
                        name: 'analysis_data_adversting_messenger',
                        meta: {
                            hideInMenu: true,
                            access: ['DATA_FACEBOOK_ADS_INSIGHTS'],
                            title: 'analysis_data_adversting_messenger',
                            icon: 'icon-fenxi',
                        },
                        component: () => import(/* webpackChunkName: "analysis" */ '@/views/main/data/Adversting/messenger/index.vue'),
                    },
                ],
            },
        ],
    },
];
